<template>
  <div class="d-flex justify-content-center body-content">
    <div class="w-100 d-flex align-items-center flex-column mt-5" style="max-width: 500px;">
      <div class="d-flex flex-column">
        <p
          class="font-18 mb-4 font-weight-bold"
          style="text-align:center"
        >
        登録時のパスワードを入力して<br/>認証を完了してください
        </p>
      </div>
      <form @submit.prevent="handleSubmit" class="w-100">
        <div class="form-group mb-4">
          <label class="cstm-label">
            パスワード
          </label>
          <div class="input-group custom-group">
            <input
              :type="inputType"
              class="form-control"
              v-bind:class="{
                'is-invalid': hasError('password'),
              }"
              name="password"
              v-model="password"
              v-validate="'required'"
              data-vv-as="パスワード"
            />
            <button
              class="btn-eye"
              type="button"
              v-on:click.prevent="showPassword"
            >
              <i :class="eyeIcon" aria-hidden="true"></i>
            </button>
            <div
              class="invalid-feedback"
              v-if="hasError('password')"
            >
              {{ getErrorMessage("password") }}
            </div>
          </div>
        </div>
        <button
          type="submit"
          class="btn btn-cstm btn-cstm-primary mt-2 h-auto py-2"
          :disabled="processing"
        >
          認証を完了する
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import Api from '@/config/api';
import swal from 'sweetalert';

export default {
  name: 'PasswordSetup',
  props: {
    token: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    buttonStyle: {
      type: Object,
      default: () => ({
        background: 'red',
        'border-color': 'red'
      })
    }
  },
  data() {
    return {
      password: '',
      inputType: 'password',
      eyeIcon: 'fa fa-eye-slash',
      processing: false,
      server_errors: {},
    };
  },
  computed: {
    isFormValid() {
      return this.password && this.password.length >= 8;
    }
  },
  methods: {
    showPassword() {
      this.inputType = this.inputType === 'password' ? 'text' : 'password';
      this.eyeIcon = this.inputType === 'password' ? 'fa fa-eye-slash' : 'fa fa-eye';
    },
    hasError(field) {
      return (
        field in this.server_errors || this.errors.first(field) !== undefined
      );
    },
    getErrorMessage(field) {
      if (this.errors.first(field) !== undefined) {
        return this.errors.first(field);
      } else if (field in this.server_errors) {
        return this.server_errors[field].msg;
      }
      return '';
    },
    async handleSubmit() {
      this.processing = true;
      this.server_errors = {};
      try {
        const check = await this.$validator.validateAll();
        if (!check) {
          this.processing = false;
          return;
        }

        
        const result = await this.axios({
          method: 'post',
          data: {
            token: this.token,
            id: this.userId,
            password: this.password,
            client_id: Api.credentials.CLIENT_ID,
            client_secret: Api.credentials.CLIENT_SECRET,
            grant_type: Api.credentials.grantTypes.PASSWORD,
          },
          url: Api.url(Api.endpoints.VerifyEmail),
        });
        
        // Emit result to parent
        this.$emit('password-submitted', result.data);
        
      } catch (error) {
        this.processing = false;
        const { response } = error;
        if (response && response.status === 401) {
          // Wrong password: show field-level error, do not redirect
          this.server_errors = {
            password: { msg: '登録時のパスワードと一致しません。' },
          };
        } else if (response && response.status === 400) {
          if (response.data.errors) {
            this.server_errors = response.data.errors;
          } else {
            await swal({
              text: 'このリンクは期限切れか無効になっています。',
              icon: 'warning',
              buttons: {
                ok: 'はい',
              },
            });
            this.$emit('redirect', 'login');
          }
        } else if (response && response.status === 422) {
          if (response.data.errors) {
            this.server_errors = response.data.errors;
          } else {
            await swal({
              text: '入力内容に問題があります。確認してください。',
              icon: 'warning',
              buttons: {
                ok: 'はい',
              },
            });
          }
        } else if (response && response.status === 503) {
          await swal({
            text: '現在サービスを一時的にご利用いただけません。しばらくしてからもう一度お試しください。',
            icon: 'warning',
            buttons: {
              ok: 'はい',
            },
          });
        } else {
          await swal({
            text: 'エラーが発生しました。もう一度お試しください。',
            icon: 'error',
            buttons: {
              ok: 'はい',
            },
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.cstm-label {
  font-weight: bold;
  margin-bottom: 0.5rem;
}



.custom-group {
  position: relative;
  max-width: 450px;
  width: 100%;
  margin-bottom: 1.5rem;
}

.btn-eye {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  z-index: 10;
}

.btn-eye:hover {
  color: #333;
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 13px;
  color: #dc3545;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
}

.is-invalid {
  border-color: #dc3545;
}

.is-valid {
  border-color: #28a745;
}

/* Hide validation icons */
.form-control.is-invalid {
  background-image: none !important;
}

.form-control.is-valid {
  background-image: none !important;
}

.btn-cstm {
  padding: 15px 20px;
  width: 100%;
  max-width: 90%;
  border-radius: 3px;
  height: 55px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  color: #fff !important;
  background-color: #FF0000 !important;
  border-color: #FF0000 !important;
}

.font-18 {
  font-size: 18px;
}

.font-16 {
  font-size: 16px;
}

@media (max-width: 768px) {
  .custom-group {
    max-width: 100%;
  }
  
  .btn-cstm {
    max-width: 100%;
  }
  
  .w-100 {
    max-width: 90% !important;
  }

  .w-85 {
    max-width: 85% !important;
  }
}
</style> 